import { NgModule, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterModule, Routes } from '@angular/router';
import {
  SELF_CHECKOUT_HASH,
  SelfCheckoutStreamStore,
} from '@formunauts/self-checkout/data-access';
import { SelfCheckout } from '@formunauts/self-checkout/domain';
import { selectAllRouteParam } from '@formunauts/shared/router/data-access';
import { NotFoundComponent } from '@formunauts/shared/ui';
import { Store } from '@ngrx/store';
import { AuthForSelfCheckoutFormComponent } from './auth-for-self-checkout-form/auth-for-self-checkout-form.component';
import { CheckoutFormComponent } from './checkout-form/checkout-form.component';
import { SelfCheckoutCompletedComponent } from './self-checkout-completed/self-checkout-completed.component';
import { SelfCheckoutPageComponent } from './self-checkout-page/self-checkout-page.component';
import { SelfCheckoutUnsubscribeComponent } from './self-checkout-unsubscribe/self-checkout-unsubscribe.component';
import { hasSelfCheckoutForm } from './self-checkout.guard';

export const verifyFormsRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: NotFoundComponent,
  },
  {
    path: ':hash',
    providers: [
      SelfCheckoutStreamStore,
      {
        provide: SELF_CHECKOUT_HASH,
        useFactory: (store = inject(Store)) =>
          SelfCheckout.Hash(
            toSignal(
              store.select(selectAllRouteParam('hash', { outlet: 'primary' })),
              {
                requireSync: true,
              },
            )()!,
          ),
      },
    ],
    children: [
      {
        path: 'unsubscribe',
        component: SelfCheckoutUnsubscribeComponent,
      },
      {
        path: 'completed',
        component: SelfCheckoutCompletedComponent,
      },
      {
        path: '',
        component: SelfCheckoutPageComponent,
        children: [
          {
            path: '',
            pathMatch: 'full',
            component: AuthForSelfCheckoutFormComponent,
          },
          {
            path: 'confirm',
            pathMatch: 'full',
            component: CheckoutFormComponent,
            canActivate: [hasSelfCheckoutForm()],
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(verifyFormsRoutes)],
  exports: [RouterModule],
})
export class SelfCheckoutFormsRoutingModule {}
